// extracted by mini-css-extract-plugin
module.exports = {"list":"ImageGalleryModal_list__taLi5","item":"ImageGalleryModal_item__2OL3e"};